import { useFieldArray, useForm } from "react-hook-form";
import { FiChevronDown, FiChevronUp, FiPlusCircle, FiTrash2 } from "react-icons/fi";
import { useEffect, useRef, useState } from "react";


import { useDispatch, useSelector } from "react-redux";
import { deleteTutorDocument, updateTutorDocuments } from "../../store/profile/profileActions";
import { CheckboxInput } from "../inputs/checkbox-input";
import { successToast } from "../../utils";
import { ProfileRole, TutorDocumentsType } from "../../store/profile/profileSlice";
import { CertificateInput } from "../profile/inputs/certificate-input";

const emptyEducationRow = () => ({
    _id: "",
    label: "",
    from: "",
    to: "",
    file: "",
    description: "",
    school: "",
});

const TutorEducation = ({ setCurrentStep }) => {
    const dispatch = useDispatch();
    const { profiles } = useSelector((state) => state.profile);
    const tutor = useSelector((state) => state.profile.currentProfile);
    const tutorProfileExist = profiles.filter(
        (v) => v.role === ProfileRole.TUTOR
    );

    const storedEducation =
        tutorProfileExist[0]?.education?.length > 0
            ? tutorProfileExist[0].education
            : (tutor?.education ?? []);

    const [removeSelected, setRemoveSelected] = useState(-1);
    const [isLoading, setIsLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false)
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        control,
        reset,
        formState: { errors }
    } = useForm({
        defaultValues: {
            noEducation: tutor?.noEducation,
            // Draft rows only; server-saved rows render as CertifElement below.
            education:
                tutor?.noEducation || (tutor?.education?.length ?? 0) > 0
                    ? []
                    : [emptyEducationRow()],
        }
    });
    const {
        fields: certificateFields,
        append: certificateAppend,
        remove: certificateRemove,
        replace: certificateReplace,
    } = useFieldArray({
        control,
        name: TutorDocumentsType.education,
    });

    const formRef = useRef(null);


    const removeCertif = async (id) => {
        await dispatch(deleteTutorDocument({ id, name: TutorDocumentsType.education }))
            .unwrap()
            .then(() => setRemoveSelected(-1));
    }
    const Remove = ({ index, id }) => {
        if (index === removeSelected) {
            return (
                <div className="flex items-center">
                    <p className='mr-1'>Remove it ?</p>
                    <button className='mr-1' onClick={(e) => { e.preventDefault(); removeCertif(id) }}>Yes</button>
                    <button className='mr-1' onClick={(e) => { e.preventDefault(); setRemoveSelected(-1) }}>No</button>
                </div>
            )
        } else {
            return (<button type="button" onClick={() => { setRemoveSelected(index) }}>
                <FiTrash2 size={20} color='#df2b47' />
            </button>)
        }
    }

    const CertifElement = ({ element, index }) => {
        return (
            <div className="border-2  flex flex-col justify-between mb-2 rounded-xl p-3">
                <div className="flex justify-between items-start">
                    <h6 className="text-nt-blue">{element.label}</h6>
                    <Remove index={index} id={element._id || element.id} />
                </div>
                <span className="min-w-[150px] text-nt-blue">
                    {element.from} - {element.toPresent ? "Present" : element.to}
                </span>
                <span className="text-nt-grey">
                    {element.school}
                </span>
                <p className="text-[14px]">{element.description}</p>
            </div>
        )
    }

    const noEducation = watch("noEducation");
    const onSubmit = async (data) => {
        setIsLoading(true);
        await dispatch(updateTutorDocuments({documents: data.education, noDocument: data.noEducation, type: TutorDocumentsType.education}))
            .unwrap()
            .then((data) => {
                setIsLoading(false);
                successToast("Modification applied successfully")
                if (data !== undefined && data.length && certificateFields.length > 0) {
                    certificateReplace([]);
                }
            });
    };

    const addEmptyCertificate = () => {
        certificateAppend(emptyEducationRow());
    };
    useEffect(() => {
        if (!tutor) return;
        const serverStored = tutor.education ?? [];
        reset({
            noEducation: tutor.noEducation,
            // Saved rows render as CertifElement cards only; field array is for new drafts (matches register flow).
            education:
                tutor.noEducation
                    ? []
                    : serverStored.length > 0
                      ? []
                      : [emptyEducationRow()],
        });
    }, [tutor?._id, tutor?.education?.length, tutor?.noEducation, reset]);


    return (
        <div className="rounded-2xl bg-white px-5 py-3 mb-5">
            <div onClick={() => setIsOpen(!isOpen)} className={`cursor-pointer flex items-center justify-between font-bold text-nt-blue border-color-nt-grey ${isOpen && "border-b-2 mb-4 pb-2 "}`}>
                Education
                {isOpen ? <FiChevronUp /> : <FiChevronDown />}
            </div>
            <div className={isOpen ? "block" : "hidden"}>
                <form ref={formRef} id="teacher-formations" className="flex flex-col [&_h2]:mb-5 [&_h2]:text-xl [&_h2]:text-nt-blue" onSubmit={handleSubmit(onSubmit)}>
                    <CheckboxInput
                        name="noEducation"
                        label="I don't have an education level"
                        register={register}
                        control={control}
                        style={{ marginBottom: "20px" }}
                    />

                    <div className="">
                        {!noEducation &&
                            storedEducation.map((el, index) => (
                                <CertifElement
                                    element={el}
                                    key={el._id || el.id}
                                    index={index}
                                />
                            ))}
                    </div>

                    {!noEducation && certificateFields.map((field, index) => (

                        <CertificateInput
                            stored={storedEducation.length}
                            key={field.id}
                            control={control}
                            hideFile={true}
                            register={register}
                            getValues={getValues}
                            watch={watch}
                            id={field.id}
                            remove={certificateRemove}
                            name="education"
                            index={index}
                            errors={errors}
                        />
                    ))}

                    {!noEducation && <button
                        type="button"
                        className='mb-4 flex justify-center m-auto w-full text-center'
                        onClick={() => {
                            addEmptyCertificate()
                        }}
                    >
                        <FiPlusCircle size={30} color='#191d51' fontWeight={700} />
                    </button>}

                    <button disabled={isLoading} className="block rounded-xl mx-auto px-5 py-2 bg-nt-blue text-white self-center mt-5">
                        Save
                    </button>
                </form>
            </div>
        </div>
    )
}

export { TutorEducation }